import { Box, styled } from '@mui/material';
import { Link } from 'react-router-dom';
import AyoLogo from 'src/Assets/Images/a_logo.png';

const LogoWrapper = styled(Link)(
  () => `
        color: inherit;
        display: flex;
        align-items: center;
        justify-content: center;
        text-decoration: none;
        width: 40px;
        height: 40px;
`
);

const LogoImg = styled('img')(
  () => `
        width: 100%;
        height: 100%;
        object-fit: contain;
        border-radius: 8px;
`
);

function Logo() {
  return (
    <LogoWrapper to="/dashboards/crypto">
      <LogoImg src={AyoLogo} alt="AYOZAT" />
    </LogoWrapper>
  );
}

export default Logo;
